<template>
  <basic-card class="global-basic-card" padding hideHeader>
    <avue-crud
      class="global-table"
      :key="tableKey"
      :option="option"
      :table-loading="loading"
      :data="data"
      ref="crud"
      v-model="form"
      v-model:page="page"
      v-model:search="search"
      :permission="permissionObj"
      :before-open="beforeOpen"
      @row-del="rowDel"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
    <!-- 不用avue带的，自定义搜索、增删查改、批量操作。 -->
      <!-- <template #search-menu>
        <div class="search-menu-box" style="padding: 2px 10px 2px 0;" v-if=" userInfo.tenant_id == '000000'">
          <div style="display: flex;">
            <comp-button
              type="default"
              icon="icon-search"
              @click.stop="handleSearch()"
              >{{ Lang.btn.search }}
            </comp-button>
            <comp-button
              type="text"
              @click.stop="handleEmpty()"
              >{{ Lang.btn.empty }}
            </comp-button>
          </div>
          <div style="display: flex;">
            <comp-button
              type="primary"
              icon="icon-add"
              v-if="permissionObj.add" 
              plain
              @click="handleAdd"
              >{{ Lang.btn.addNew }}
            </comp-button>
            <comp-button
              type="normal"
              @click="toggleShowMore()"
              >{{ Lang.btn.batchOperation }}
            </comp-button>
          </div>
        </div>
      </template> -->
      <!-- 点更多打开的按钮 -->
      <template #header>
        <div class="search-menu-box-others" style="display: flex; justify-content: space-between;" v-if="showMore">
          <CompSearch 
            v-model="search.tenantName"
            :placeholder="Lang.tips.plzInput + Lang.Title.enterpriseEntpName"
            @change="handleSearch()"
          />
          <comp-button
            type="primary"
            icon="icon-add"
            v-if="permissionObj.add && userInfo.tenant_id == '000000'" 
            plain
            @click="handleAdd"
            >{{ Lang.btn.addNew }}
          </comp-button>
          <!-- <comp-button
            type="delete"
            v-if="permissionObj.delete" 
            plain
            @click="handleDelete"
            >{{ Lang.btn.batchDelete }}
          </comp-button> -->
        </div>
      </template>
      <!-- 操作菜单按钮 -->
      <template #menu="{row}">
        <div class="operation-btns">
          <CompIconButton :auth="permissionObj" type="view" @click="handleView(row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="edit" v-if="row.tenantId != '000000'" @click="handleEdit(row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="resetPassword" @click="handleResetPassword(row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="disable" v-if="row.status == 1 && row.tenantId != '000000'" @click="handleStatus(row, 0)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="enable" v-if="row.status == 0 && row.tenantId != '000000'" @click="handleStatus(row, 1)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" :text="Lang.Button.enterprisePermiss" type="setting" @click="handleAuthConfig(row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="delete" v-if="row.tenantId != '000000'" :divider="false" @click="handleDel(row)" > </CompIconButton>
        </div>
      </template>
      <template #phone="{ row }">
        <el-tag  v-if="row.phone"> {{'+'+row.areaCode }} {{ row.phone }}</el-tag>
      </template>
      <template #accountNumber="{ row }">
        <el-tag>{{ row.accountNumber > 0 ? row.accountNumber : Lang.tips.unLimit }}</el-tag>
      </template>
      <template #expireTime="{ row }">
        <el-tag>{{ row.expireTime ? $dayjs(row.expireTime).format('YYYY-MM-DD') : Lang.tips.unLimit }}</el-tag>
      </template>
    </avue-crud>

    <!-- 配置权限弹窗 -->
    <el-dialog class="global-dialog" :title="Lang.title.roleAuthConfig" :close-on-click-modal="false" append-to-body v-model="authDialogBox" width="745px">
      <el-tabs type="border-card">
        <el-tab-pane :label="Lang.label.menuAuth">
          <el-tree
            :data="menuGrantList"
            show-checkbox
            node-key="id"
            ref="treeMenu"
            :default-checked-keys="[]"
            :props="authTreeProps"
            :check-strictly="true"
            @check-change="handleMenuCheckChange"
          >
          </el-tree>
        </el-tab-pane>
        <el-tab-pane :label="Lang.label.openApiAuth">
          <el-tree
            :data="openApiScopeGrantList"
            show-checkbox
            node-key="id"
            ref="treeOpenApiScope"
            :default-checked-keys="openApiTreeObj"
            :props="authTreeProps"
          >
          </el-tree>
        </el-tab-pane>
      </el-tabs>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="authDialogBox = false">{{ Lang.btn.cancel }}</el-button>
          <el-button type="primary" @click="submitAuth">{{ Lang.btn.confirm }}</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 重置密码弹窗 -->
    <el-dialog :title="Lang.Button.enterpriseResetPass"
      :close-on-click-modal="false"
      append-to-body
      modal
      class="global-dialog"
      v-model="resetPasswordBox" width="450px">
      <el-form
        labelPosition="top"
        :model="resetPasswordForm"
        :rules="resetPasswordFormRules"
        ref="resetPasswordForm"
        @submit="handleResetPasswordSubmit">
        <el-form-item :label="Lang.Text.enterpriseEntpc" prop="tenantName">
          <el-input v-model="resetPasswordForm.tenantName" disabled></el-input>
        </el-form-item>
        <el-form-item :label="Lang.Title.enterpriseNewPass" prop="password">
          <el-input maxlength="18" 
            @input="realeTimeCheckPhone"
            :placeholder="Lang.tips.plzInputNewPassword"
            v-model="resetPasswordForm.password"
            type="password"></el-input>
        </el-form-item>
      </el-form>
      <div class="el-dialog__footer">
        <el-button @click="resetPasswordBox = false">{{ Lang.btn.cancel }}</el-button>
        <el-button type="primary" @click="handleResetPasswordSubmit">{{ Lang.btn.confirm }}</el-button>
      </div>
    </el-dialog>

    <!-- 新增编辑企业弹窗 -->
    <el-dialog 
      :close-on-click-modal="false"
      :title="this.operationType == 'edit' ? Lang.Text.permissEditEntp : Lang.Text.permissAddEntp"
      append-to-body
      class="global-dialog"
      v-model="enterpriseDialog"
      size="80%" >
      <avue-form
        v-if="enterpriseDialog"
        :option="enterpriseOption"
        ref="enterpriseFormRef"
        v-model="enterpriseForm"
        @submit="handleSubmitEnterprise">
        <template #phone="{ row }">
          <CompPhone 
            v-model="enterpriseForm.phone" 
            @change="handlePhoneChange"
          />
        </template>
        <template #menu-form>
          <div class="dialog-footer">
            <el-button v-if="operationType!='view' && permissionObj.edit" @click="enterpriseDialog = false">{{ Lang.btn.cancel }}</el-button>
            <el-button v-if="operationType!='view' && permissionObj.edit" type="primary" @click="() => {this.$refs.enterpriseFormRef.submit()}">{{ Lang.btn.confirm }}</el-button>
          </div>
        </template>
      </avue-form>
    </el-dialog>

  </basic-card>
</template>

<script>
import {
  getList,
  getDetail,
  update,
  add,
  updateStatus,
  recycle,
} from '@/api/system/tenant';
import {
  resetPassword,
  getCountryCodeList,
} from '@/api/system/user';
import {
  grant,
  getRole,
  grantTree,
} from '@/api/system/role';
import { mapGetters } from 'vuex';
import { validateWord, validatePasswordSimple, validatePassword, validateEmail } from '@/utils/validator'
import { filterDollarKeys } from '@/utils/util';
import CompPhone from '@/components/comp-phone/index.vue';
import CompSearch from '@/components/comp-search/index.vue';


export default {
  components: {
    CompPhone,
    CompSearch,
  },
  data() {
    return {
      tableKey: 0,
      showMore: true,
      form: {},
      enterpriseForm: {
        expireTime: ''
      },
      enterpriseDialog: false,
      hasTakeOutMenuIds: false, // 是否已回显菜单ids
      countryCodeList: [],
      defaultAreaCode: '',
      operationType: '',
      resetPasswordFormRules: {
        'password': [
          { required: true, validator: validatePassword, trigger: 'blur' },
          // { min: 1, max: 100, validator: validatePassword, trigger: 'click' },
        ],
      },
      resetPasswordForm: {
        password: ''
      },
      resetPasswordOption: {
        submitText: this.Lang.btn.confirm,
        emptyText: this.Lang.btn.cancel,
        column: [
          {
            label: this.Lang.Title.enterpriseEntpName,
            prop: 'name',
            span: 24,
            disabled: true,
          },
          {
            label: this.Lang.label.newPassword,
            prop: 'password',
            span: 24,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputNewPassword,
                trigger: 'blur',
              },
              {
                min: 6,
                max: 20,
                message: this.Lang.tips.passwordLength,
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      resetPasswordBox: false,

      selectionList: [],
      query: {},
      search: {},
      loading: true,
      datasourceBox: false,
      authDialogBox: false,
      packageBox: false,
      packageSettingBox: false,
      recycleMode: false,

      menuGrantList: [],
      openApiScopeGrantList: [],
      menuTreeSelectedIds: [],
      openApiTreeObj: [],
      authTreeProps: {
        label: 'title',
        value: 'key',
      },

      selectionList: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      enterpriseOption: {
        labelPosition: 'top',
        labelSuffix: ' ',
        gutter: 16,
        emptyBtn: false,
        submitBtn: false,
        column: [
          // {
          //   label: 'ID',
          //   prop: 'tenantId',
          //   hide: true,
          //   addDisplay: false,
          //   editDisplay: false,
          //   span: 24,
          // },
          {
            label: this.Lang.Title.enterpriseEntpName,
            prop: 'tenantName',
            search: true,
            maxlength: 100,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInput + this.Lang.Title.enterpriseEntpName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.Title.enterpriseExpriDate,
            prop: 'expireTime',
            type: 'date',
            format: 'YYYY-MM-DD 23:59:59',
            valueFormat: 'YYYY-MM-DD 23:59:59',
            slot: true,
            addDisplay: true,
            editDisplay: true,
            rules: [
              {
                required: true,
                message:  this.Lang.tips.plzSelect + this.Lang.Title.enterpriseExpriDate,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.Title.enterpriseCustomDomin,
            prop: 'domainUrl',
            search: false,
            hide: true,
            addDisplay: true,
            editDisplay: true,
            rules: [
              {
                required: false,
                message: this.Lang.tips.plzInputParamName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.Title.enterpriseCurrenct,
            prop: 'currencyCode',
            search: false,
            hide: true,
            rules: [
              {
                required: false,
                message: this.Lang.tips.plzInputParamName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.Title.enterpriseAcc,
            prop: 'admin',
            value: 'admin',
            search: false,
            hide: true,
            disabled: true,
          },
          {
            label: this.Lang.Title.enterprisePass,
            prop: 'password',
            search: false,
            display: false,
            maxlength: 18,
            rules: [
              {
                validator: validatePassword,
                trigger: 'blur',
                required: true,
              },
            ],
          },
          {
            label: this.Lang.Title.enterpriseContact,
            prop: 'name',
            maxlength: 100,
          },
          {
            label: this.Lang.Title.enterpriseContactNo,
            prop: 'phone',
            maxlength: 13,
          },
          // {
          //   label: 'Status',
          //   prop: 'statusDesc',
          //   hide: false,
          //   addDisplay: false,
          //   editDisplay: false,
          // },
          {
            label: this.Lang.Title.enterpriseEmail,
            prop: 'email',
            hide: true,
            rules: [
              {
                required: false,
                trigger: 'blur',
                validator: validateEmail,
              },
            ],
          },
          // {
          //   label: 'Creater',
          //   prop: 'createUserName',
          //   hide: false,
          //   addDisplay: false,
          //   editDisplay: false,
          // },
          // {
          //   label: 'Created  Time',
          //   prop: 'createTime',
          //   type: 'date',
          //   format: 'YYYY-MM-DD HH:mm:ss',
          //   valueFormat: 'YYYY-MM-DD HH:mm:ss',
          //   slot: true,
          //   addDisplay: false,
          //   editDisplay: false,
          // },
          // {
          //   label: 'Updated By',
          //   prop: 'updateUserName',
          //   addDisplay: false,
          //   editDisplay: false,
          // },
          // {
          //   label: 'Updated Time',
          //   prop: 'updateTime',
          //   type: 'date',
          //   format: 'YYYY-MM-DD HH:mm:ss',
          //   valueFormat: 'YYYY-MM-DD HH:mm:ss',
          //   slot: true,
          //   addDisplay: false,
          //   editDisplay: false,
          //   hide: false,
          // },
        ],
      },
      option: {
        height: 'auto',
        calcHeight: 'auto',
        tip: false,
        searchShow: true,
        searchSpan: 4,
        searchMenuSpan: 16,
        searchMenuPosition: 'right',
        searchLabelWidth: 'auto',
        searchGutter: 20,
        gutter: 12,
        border: true,
        index: false,
        menu: true,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        selection: false,
        menuWidth: 206, // 操作列宽
        viewBtn: false, // 查看
        editBtn: false, // 编辑
        delBtn: false, // 删除
        addBtn: false, // 左上角新增
        emptyBtn: false, // 隐藏原来的删除按钮
        searchBtn: false, // 隐藏原来的搜索按钮
        menuType: 'button',
        menuTitle: this.Lang.label.operation,
        menuHeaderAlign: 'right', // 操作按钮样式
        dialogWidth: 900,
        dialogClickModal: false,
        dialogType: 'drawer',
        labelWidth: 'auto',
        searchLabelPosition: 'left',
        labelPosition: 'top',
        showOverflowTooltip: true,
        dialogCustomClass: 'dialog-custom-class-sort',
        column: [
          {
            label: 'ID',
            prop: 'tenantId',
            search: false,
            addDisplay: false,
            editDisplay: false,
            span: 24,
            rules: [
              {
                required: true,
                message: this.Lang.tips.inputTenantId,
                trigger: 'blur',
              },
              {
                message: this.Lang.tips.plzInputEnCharater,
                trigger: 'blur',
                validator: validateWord,
              },
            ],
          },
          {
            label: this.Lang.Title.enterpriseEntpName,
            prop: 'tenantName',
            search: false,
            maxlength: 100,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputParamName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.Title.enterpriseContact,
            prop: 'name',
            maxlength: 100,
          },
          {
            label: this.Lang.Title.enterpriseContactNo,
            prop: 'phone',
            slot: true,
            maxlength: 13,
          },
          {
            label: this.Lang.Title.enterpriseStatus,
            prop: 'statusDesc',
            hide: false,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: this.Lang.Title.enterpriseExpriDate,
            prop: 'expireTime',
            type: 'date',
            format: 'YYYY-MM-DD HH:mm:ss',
            valueFormat: 'YYYY-MM-DD HH:mm:ss',
            slot: true,
            addDisplay: true,
            editDisplay: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelect + this.Lang.Title.enterpriseExpriDate,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.Title.enterpriseCustomDomin,
            prop: 'domainUrl',
            search: false,
            hide: true,
            addDisplay: true,
            editDisplay: true,
            rules: [
              {
                required: false,
                message: this.Lang.tips.plzInputParamName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.Title.enterpriseCurrenct,
            prop: 'currencyCode',
            search: false,
            hide: true,
            rules: [
              {
                required: false,
                message: this.Lang.tips.plzInputParamName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.Title.enterpriseAcc,
            prop: 'admin',
            value: 'admin',
            search: false,
            hide: true,
            disabled: true,
          },
          {
            label: this.Lang.Title.enterprisePass,
            prop: 'password',
            search: false,
            hide: true,
            addDisplay: true,
            editDisplay: false,
            viewDisplay: false,
            maxlength: 18,
            rules: [
              {
                validator: validatePassword,
                trigger: 'blur',
              },
            ],
          },


          
          {
            label: this.Lang.Title.enterpriseEmail,
            prop: 'email',
            hide: true,
            rules: [
              {
                required: false,
                trigger: 'blur',
                validator: validateEmail,
              },
            ],
          },
          {
            label: this.Lang.Title.enterpriseCreator,
            prop: 'createUserName',
            hide: false,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: this.Lang.Title.enterpriseCreateTime,
            prop: 'createTime',
            type: 'date',
            format: 'YYYY-MM-DD HH:mm:ss',
            valueFormat: 'YYYY-MM-DD HH:mm:ss',
            slot: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: this.Lang.Title.enterpriseUpdateBy,
            prop: 'updateUserName',
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: this.Lang.Title.enterpriseUpdateTime,
            prop: 'updateTime',
            type: 'date',
            format: 'YYYY-MM-DD HH:mm:ss',
            valueFormat: 'YYYY-MM-DD HH:mm:ss',
            slot: true,
            addDisplay: false,
            editDisplay: false,
            hide: false,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['menuItem', 'permission', 'userInfo', 'language']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
          obj.resetPassword = this.permission[key];
        }
      }))
      this.option.selection = this.userInfo.tenant_Id == '000000'
      // obj.enable = true;
      // obj.disable = true;
      // obj.resetPassword = true;
      console.log('permissionObj', obj)
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
    tenantId() {
      return this.selectionList[0].tenantId;
    },
  },
  mounted() {
    this.initData();
    if (this.userInfo.tenant_id == '000000') {
      this.option.menu = true;
    } else {
      this.option.menu = false;
    }
  },
  methods: {
    // 自定义查看
    handleView(row) {
      this.togglePasswordRow(false)
      this.$refs.crud.rowView(row);
      // this.operationType = 'view';
      // this.enterpriseForm = row;
      // this.enterpriseDialog = true;
    },
    // 自定义编辑
    handleEdit(row) {
      this.operationType = 'edit';
      if (row.expireTime) {
        row.expireTime = this.$dayjs(row.expireTime).format('YYYY-MM-DD 23:59:59');
      }
      this.enterpriseForm = row;
      this.togglePasswordRow(false)
      this.enterpriseDialog = true;
    },
    // 自定义删除
    handleDel(row) {
      this.$refs.crud.rowDel(row);
    },
    // 自定义新增
    handleAdd() {
      this.operationType = 'add';
      this.enterpriseForm = {
        expireTime: ''
      };
      this.togglePasswordRow(true)
      this.enterpriseDialog = true;
    },
    togglePasswordRow(flag) {
      const column = this.findObject(this.enterpriseOption.column, 'password');
      column.display = flag;
    },
    // 自定义搜索
    handleSearch() {
      console.log(this.search);
      const params = filterDollarKeys(this.search);
      this.onLoad(this.page, params);
    },
    // 自定义清空
    handleEmpty() {
      this.$refs.crud.searchReset();
    },
    // 自定义展示更多
    toggleShowMore() {
      this.showMore = !this.showMore;
      this.tableKey += 1;
    },
    // 修改状态
    handleStatus(row, status) {
      const params = {
        id: row.id,
        status: status,
      };
      updateStatus(params).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        },
        error => {
          window.console.log(error);
        }
      );
    },
    handlePhoneChange(data) {
      this.enterpriseForm.phone = data.phoneNumber;
      this.enterpriseForm.areaCode = data.countryCode;
    },
    // 选父级把子级都选上
    handleMenuCheckChange(node, checked) {
      if (!this.hasTakeOutMenuIds) { // 回显完才允许关联选择下级
        return;
      }
      const tree = this.$refs.treeMenu; // 获取树组件的引用
      console.log('checked', checked)
      // // 递归勾选子节点
      const checkChildren = (node) => {
        if (node.children && node.children.length > 0) {
          node.children.forEach((child) => {
            tree.setChecked(child.id, checked); // 勾选或取消勾选子节点
            checkChildren(child); // 递归处理子节点
          });
        }
      };

      // 勾选当前节点的子节点
      checkChildren(node);
    },
    // 配置权限
    handleAuthConfig(row) {
      // if (this.selectionList.length !== 1) {
      //   this.$message.warning(this.Lang.tips.onlyCanSelectOne);
      //   return;
      // }
      this.selectionList = [row];
      this.menuTreeSelectedIds = [];
      this.openApiTreeObj = [];
      grantTree({
        opType: 1, // 操作类型1:企业菜单和接口权限 2.角色菜单和角色接口权限
        tenantId: row.tenantId,
        roleIds: [this.ids],
      }).then(resp => {
        this.menuGrantList = resp.data.data.menu;
        this.openApiScopeGrantList = resp.data.data.openApi;
        getRole({
          tenantId: row.tenantId,
          opType: 1, // 操作类型1:企业菜单和接口权限 2.角色菜单和角色接口权限
        }).then(res => {
          const menuTreeSelectedIds = res.data.data.menu;
          this.menuTreeSelectedIds = menuTreeSelectedIds;
          this.openApiTreeObj = res.data.data.openApi;
          this.authDialogBox = true;
          this.hasTakeOutMenuIds = false;
          this.$nextTick(() => {
            const treeMenu = this.$refs.treeMenu;
            console.log('回显IDs', menuTreeSelectedIds)
            treeMenu.setCheckedKeys(menuTreeSelectedIds, true); // 回显
            setTimeout(() => {
              this.hasTakeOutMenuIds = true;
            }, 0)
          })
        });
      });
    },
    submitAuth() {
      const menuList = this.$refs.treeMenu.getCheckedKeys();
      const openApiScopeList = this.$refs.treeOpenApiScope.getCheckedKeys();
      const tenantId = this.selectionList[0]?.tenantId;
      grant({
        menuIds: menuList,
        openApiIds: openApiScopeList,
        tenantId,
        roleIds: [this.selectionList[0]?.roleId],
        opType: 1, // 操作类型1:企业菜单和接口权限 2.角色菜单和角色接口权限
      }).then(() => {
        this.authDialogBox = false;
        this.$message({
          type: 'success',
          message: this.Lang.tips.operationSuccess,
        });
        this.onLoad(this.page);
      });
    },
    handleResetPassword(row) {
      this.selectionList = [row];
      this.resetPasswordForm = {
        id: row.id,
        userId: row.userId,
        tenantName: row.tenantName,
        tenantId: row.tenantId,
        password: '',
      };
      this.resetPasswordBox = true;
    },
    realeTimeCheckPhone() {
      this.$refs.resetPasswordForm.validateField('password', (err) => {
        console.log('err', err)
      }); // 触发密码字段的校验
    },
    handleResetPasswordSubmit() {
      const form = this.resetPasswordForm;
      if (!validatePasswordSimple(form.password)) {
        this.$message.error(this.Lang.Text.userOrgPassLength);
        return;
      }
      resetPassword(form.userId, form.password).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.resetPasswordBox = false;
          this.onLoad(this.page, this.query);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    initData() {
      getCountryCodeList().then(res => {
        const data = res.data.data;
        data.forEach(item => {
          item.label = item.countryCode;
          item.value = item.countryCode;
        });
        const item = data.find(ele => ele.languageType == this.language) || {}
        this.defaultAreaCode = item.countryCode;
        this.enterpriseForm.areaCode = item.countryCode;
        this.countryCodeList = data;
      });
    },
    handleSubmitEnterprise(form, done) {
      const submitFunction = this.operationType === 'edit' ? add : update;
      const params = {
        ...form,
        tenantId: this.userInfo.tenant_id,
      };
      if (!params.areaCode) {
        params.areaCode = this.defaultAreaCode;
      }
      submitFunction(params).then(
        res => {
          // 获取新增数据的相关字段
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          // 数据回调进行刷新
          this.enterpriseDialog = false;
          this.onLoad(this.page);
          done();
        },
        error => {
          window.console.log(error);
          done();
        }
      );
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm(this.Lang.tips.ifConfirmDeleteTenant, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return recycle(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    beforeOpen(done, type) {
      // if (['view'].includes(type)) {
      //   getDetail(this.form.id).then(res => {
      //     const data = res.data.data;
      //     if (!(data.accountNumber > 0)) {
      //       data.accountNumber = this.Lang.tips.unLimit;
      //     }
      //     if (!data.expireTime) {
      //       data.expireTime = this.Lang.tips.unLimit;
      //     }
      //     this.form = data;
      //   });
      // }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDeleteTenant, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return recycle(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getList(
        page.currentPage,
        page.pageSize,
        Object.assign(params, this.query, {
          status_equal: this.recycleMode ? -1 : 1,
        })
      ).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style></style>
